import styled from 'styled-components';

import { createVar, sizeUp, vars } from '~/theme';
import { DesignSidePanelSt } from '~organisms/DesignSidePanel';
import { layoutVars } from '~templates/Layout';

const _sidePanelWidth = createVar('_sidePanelWidth');

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  ...vars({
    [_sidePanelWidth]: sizeUp('50%', ['md', 'min(55%, 1100rem)']),
  }),

  [`${DesignSidePanelSt.Container}`]: {
    width: _sidePanelWidth,

    marginLeft: '30rem',
    position: 'absolute',
    // extends the panel by the same amount PanelContent spends on top clearance,
    // so that clearance is not paid for out of the scrollable content height
    insetBlock: `0 calc(-16rem - ${layoutVars.nextStepBtnClearance})`,
    insetInline: `calc(100% - ${_sidePanelWidth}) 0`,
    zIndex: theme.overlayPosition.layer10,
  },

  [`${DesignSidePanelSt.PanelContent}`]: {
    paddingBlockStart: layoutVars.nextStepBtnClearance,
  },
}));

export const DrawingAreaContainer = styled.div({
  inlineSize: `calc(100% - ${_sidePanelWidth} - 10rem)`,
  flex: 1,
  marginRight: `calc(${_sidePanelWidth} + 10rem)`,
  height: '100%',
});
